import { createFileRoute } from "@tanstack/react-router";
import { AndroidVsLinuxStbPage } from "@/components/guides/AndroidVsLinuxStbPage";
import { androidVsLinuxStbSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/guides/android-vs-linux-stb")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) =>
    androidVsLinuxStbSeo(loaderData?.href ?? "/guides/android-vs-linux-stb"),
  component: AndroidVsLinuxStbPage,
});
